export const usePowerCalcStore = defineStore("powerCalcStore", {
  state() {
    return {
      selectedItems: {
        MEDIA_AND_GADGETS: [],
        HOUSEHOLD_APPLIANCES: [],
        CLIMATE_AND_LIGHTING: [],
        OTHER: [],
      },
      allSelectedItems: [],
    };
  },
  actions: {
    setItems(categoryType, item, count) {
      const existingItems = this.selectedItems[categoryType] || [];
      const existingCount = existingItems.filter(
        (existingItem) => existingItem.itemName === item.itemName,
      ).length;

      this.selectedItems[categoryType] = existingItems.filter(
        (existingItem) => existingItem.itemName !== item.itemName,
      );
      const newItems = Array.from({ length: count }, (_, i) => ({
        ...item,
        index: `${item.itemName}-${existingCount + i + 1}`,
      }));

      this.selectedItems[categoryType] =
        this.selectedItems[categoryType].concat(newItems);

      this.updateAllSelectedItems();
    },
    updateAllSelectedItems() {
      this.allSelectedItems = Object.values(this.selectedItems).flat();
    },
    removeSelectedItem(item) {
      this.allSelectedItems = this.allSelectedItems.filter(
        (existingItem) => existingItem.index !== item.index,
      );

      for (const category in this.selectedItems) {
        this.selectedItems[category] = this.selectedItems[category].filter(
          (existingItem) => existingItem.index !== item.index,
        );
      }
    },
    updateItemProperty(index, property, value) {
      const item = this.allSelectedItems.find(
        (existingItem) => existingItem.index === index,
      );
      if (item) {
        item[property] = value;
      }

      for (const category in this.selectedItems) {
        const categoryItems = this.selectedItems[category];
        const categoryItem = categoryItems.find(
          (existingItem) => existingItem.index === index,
        );
        if (categoryItem) {
          categoryItem[property] = value;
          break;
        }
      }
    },
    updateTimeUnit(index, newTimeUnit) {
      const currentItem = this.allSelectedItems.find(
        (item) => item.index === index,
      );
      const currentTimeValue = currentItem.timeValue;

      this.updateItemProperty(index, "timeUnit", newTimeUnit);

      if (newTimeUnit === "hours") {
        const hours = Math.ceil(currentTimeValue / 60);
        this.updateItemProperty(index, "timeValue", hours);
      } else if (newTimeUnit === "minutes") {
        const minutes = currentTimeValue * 60;
        this.updateItemProperty(index, "timeValue", minutes);
      }
    },
  },
  getters: {
    getSelectedItems: (state) => {
      return state.selectedItems;
    },
    getSelectedItemsByCategory: (state) => {
      return (category) => {
        return state.selectedItems[category] || [];
      };
    },
    getAllSelectedItems: (state) => {
      return state.allSelectedItems;
    },
  },
});
